export default function userHasRoles(userRoles, neededRoles) {
  return (
    !neededRoles ||
    neededRoles.length === 0 ||
    (userRoles && userRoles.some(item => neededRoles.includes(item.code)))
  )
}
